<script setup lang="ts">
  import { computed } from 'vue';
  import type { FormElement, EmailInputProperties } from '../../../model/form.types';
  import { useFormBuilderDisplayInput } from '../../../model/useFormBuilderDisplayInput';

  interface Props {
    element: FormElement & { properties: EmailInputProperties };
  }

  const props = defineProps<Props>();

  const { inputValue, isLabelLeft, inputClasses, labelClasses, labelStyles, containerStyles, isEditable } =
    useFormBuilderDisplayInput(() => props.element, 'EMAIL_INPUT');

  const placeholderText = computed(() => props.element.properties.placeholder);
</script>

<template>
  <div
    class="form-builder-simple-input"
    :class="{ 'label-left': isLabelLeft }"
    :style="containerStyles"
  >
    <label
      :for="`input-${element.id}`"
      :class="labelClasses"
      :style="labelStyles"
    >
      {{ element.properties.label }}
    </label>
    <input
      :id="`input-${element.id}`"
      :value="inputValue"
      type="email"
      :name="element.properties.name"
      :placeholder="placeholderText"
      :required="element.properties.required"
      :aria-label="element.properties.label || element.properties.name"
      :readonly="!isEditable"
      :class="inputClasses"
    >
  </div>
</template>

<style scoped>
  @import './form-builder-simple-input.css';
</style>
